/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Age_LabelInputs */

const en_us2_bodymap_age_label = /** @type {(inputs: Bodymap_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long ago?`)
};

const pt_br2_bodymap_age_label = /** @type {(inputs: Bodymap_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há quanto tempo?`)
};

const es_419_bodymap_age_label = /** @type {(inputs: Bodymap_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Hace cuánto?`)
};

const pt_pt2_bodymap_age_label = /** @type {(inputs: Bodymap_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há quanto tempo?`)
};

const fr_fr2_bodymap_age_label = /** @type {(inputs: Bodymap_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a combien de temps ?`)
};

const de_de2_bodymap_age_label = /** @type {(inputs: Bodymap_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange ist das her?`)
};

const it_it2_bodymap_age_label = /** @type {(inputs: Bodymap_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo fa?`)
};

/**
* | output |
* | --- |
* | "How long ago?" |
*
* @param {Bodymap_Age_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_age_label = /** @type {((inputs?: Bodymap_Age_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Age_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_age_label(inputs)
	if (locale === "es-419") return es_419_bodymap_age_label(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_age_label(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_age_label(inputs)
	if (locale === "de-DE") return de_de2_bodymap_age_label(inputs)
	if (locale === "it-IT") return it_it2_bodymap_age_label(inputs)
	return en_us2_bodymap_age_label(inputs)
});
export { bodymap_age_label as "bodymap.age.label" }